import CircularProgress from "@material-ui/core/CircularProgress";
import _ from "lodash";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { trackEvent } from "../../../_utils/GoogleAnalytics";
import { buildLocaleQuery, parseLocaleQuery, resolveLocaleContext } from "../../../_utils/localeContext";
import "../../../styles/CustomButton.css";
import "../styles/Search.css";

const KB_FAMILY_STORES = ["KB", "NZ", "SG", "AU", "US", "CAEN", "CAFR"];
const KB_COUNTRIES = ["NZ", "SG", "AU", "US", "CA"];
const KB_LEGACY_ORDER_PREFIXES_BY_COUNTRY = {
    CA: ["CAEN", "CAFR"]
};

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order_no: "",
            order_no_error_message: "",
            email: "",
            email_error_message: ""
        };
    }

    getRequestedStoresFromQuery() {
        const localeQuery = parseLocaleQuery(this.props.location.search);
        return Array.isArray(localeQuery.stores) ? localeQuery.stores : [];
    }

    getNavigationLocaleParams() {
        const localeQuery = parseLocaleQuery(this.props.location.search);
        const queryStores = Array.isArray(localeQuery.stores) ? localeQuery.stores : [];

        return {
            store: queryStores.length > 0 ? queryStores : this.props.store,
            language: localeQuery.language || this.props.language,
            country: localeQuery.country || this.props.country
        };
    }

    getPrimaryRequestedStore() {
        const queryStores = this.getRequestedStoresFromQuery();
        if (queryStores.length > 0) {
            return queryStores[0];
        }

        return this.props.store && this.props.store[0] ? this.props.store[0] : null;
    }

    getOrderNumberPlaceholder() {
        const localeQuery = parseLocaleQuery(this.props.location.search);
        const queryStores = this.getRequestedStoresFromQuery();
        const currentStores = Array.isArray(this.props.store) ? this.props.store : [];
        const requestedCountry = localeQuery.country || this.props.country;
        const domainStore = KB_COUNTRIES.includes(requestedCountry) ? requestedCountry : null;

        const isKbLaunchContext = queryStores.includes("KB") || currentStores.includes("KB");
        const legacyPrefixes = KB_LEGACY_ORDER_PREFIXES_BY_COUNTRY[requestedCountry];
        if (isKbLaunchContext && legacyPrefixes && legacyPrefixes.length > 0) {
            return ["KB12345", ...legacyPrefixes.map(prefix => `${prefix}12345`)].join("/");
        }

        if (isKbLaunchContext && domainStore) {
            return `KB12345/${domainStore}12345`;
        }

        const primaryStore = this.getPrimaryRequestedStore();
        if (!primaryStore) {
            return null;
        }

        const placeholderStore = primaryStore === "CORPORATE" ? "CORP" : primaryStore;
        return `${placeholderStore}12345`;
    }

    getResolvedContext = () => {
        return resolveLocaleContext({
            search: this.props.location.search,
            store: this.props.store,
            language: this.props.language,
            country: this.props.country,
            storeList: this.props.store_list,
            countryList: this.props.country_list
        });
    };

    getValidStorePlaceholder() {
        return this.props.store && this.props.store[0] && (this.props.store[0] === "CORPORATE" ? "CORP" : this.props.store[0]);
    }

    getSearchStoreScope() {
        const requestedStores = this.getRequestedStoresFromQuery();
        const currentStores = Array.isArray(this.props.store) ? this.props.store : [];
        const scopedStores = _.uniq([...requestedStores, ...currentStores]);
        const currentCountry = this.props.country;

        const isKbContext = scopedStores.some(store => KB_FAMILY_STORES.includes(store)) || KB_COUNTRIES.includes(currentCountry);

        if (!isKbContext) {
            const primaryStore = this.getPrimaryRequestedStore();
            return primaryStore ? [primaryStore] : scopedStores;
        }

        const allowedStores = this.props.store_list && this.props.store_list.length > 0 ? this.props.store_list : KB_FAMILY_STORES;
        return _.uniq([...scopedStores, ...KB_FAMILY_STORES]).filter(store => allowedStores.includes(store));
    }

    emailValid(email) {
        const regex = /.+@.+\..+/;
        return regex.test(email.trim());
    }

    getViewQueryParameters() {
        const resolved = this.getResolvedContext();

        if (JSON.stringify(this.props.store) !== JSON.stringify(resolved.store)) {
            this.props.setStore(resolved.store);
        }

        if (this.props.language !== resolved.language) {
            this.props.setLanguage(resolved.language);
        }

        if (this.props.country !== resolved.country) {
            this.props.setCountry(resolved.country);
        }
    }

    componentDidMount() {
        this.props.resetLanguage();
        this.props.resetStore();
        this.props.resetCountry();

        if (this.props.language_list.length === 0) {
            this.props.getLanguages();
        }

        if (this.props.store_list.length === 0) {
            this.props.getStores();
        }

        if (this.props.country_list.length === 0) {
            this.props.getCountries();
        }

        this.getViewQueryParameters();

        if (this.props.search_results !== null && !_.isEmpty(this.props.search_results)) {
            this.props.resetSearchResult();
        }

        this.postMessageToParentWindow();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.search_order_id !== this.props.search_order_id && !_.isEmpty(this.props.search_results) && this.props.search_order_id !== null) {
            trackEvent("Search", "Search Order", "true");
            const query = buildLocaleQuery(this.getNavigationLocaleParams());
            this.props.history.push(`/embedded/orders/${this.props.search_order_id}?${query}`);
        }

        if (
            (prevProps.search_order_no !== this.props.search_order_no || prevProps.search_email !== this.props.search_email) &&
            this.props.search_order_id === null
        ) {
            trackEvent("Search", "Search Order", "false");
            const { locale } = this.getResolvedContext();
            this.props.updateSearchMessage(locale.SEARCH_PAGE.FEEDBACK_MESSAGE.ORDER_NOT_FOUND);
        }

        if (
            this.props.language_list !== prevProps.language_list ||
            this.props.store_list !== prevProps.store_list ||
            this.props.country_list !== prevProps.country_list
        ) {
            this.getViewQueryParameters();
        }

        if (prevProps.loading === true && this.props.loading === false && this.props.searchError) {
            const { locale } = this.getResolvedContext();
            this.props.updateSearchMessage(locale.SEARCH_PAGE.FEEDBACK_MESSAGE.ORDER_NOT_FOUND);
        }

        this.postMessageToParentWindow();
    }

    postMessageToParentWindow() {
        let rootElement = document.getElementById("root");
        let height = Math.max(rootElement.scrollHeight, rootElement.offsetHeight, rootElement.clientHeight);

        let data = {
            action: "SITE_UPDATED",
            height
        };
        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    handleInputChange = (input_name, e) => {
        this.setState({
            [input_name]: e.target.value,
            [`${input_name}_error_message`]: ""
        });
    };

    handleForgotOrderNoClick = () => {
        this.props.resetSearchMessage();
        trackEvent("Search", "Forgot Order", "true");
    };

    getForgotOrderNoPath = () => {
        const query = buildLocaleQuery(this.getNavigationLocaleParams());
        return `/embedded/search/forgot-order-no?${query}`;
    };

    resetErrorMessages() {
        this.setState({
            order_no_error_message: "",
            email_error_message: ""
        });
    }

    handleSearch = () => {
        this.props.resetSearchResult();
        this.props.resetSearchMessage();
        this.resetErrorMessages();

        const { locale } = this.getResolvedContext();
        const searchLocale = locale.SEARCH_PAGE;
        const errors = {};

        if (!this.state.order_no) {
            errors.order_no_error_message = searchLocale.ORDER_NUMBER_INPUT.ERROR_REQUIRED;
        }

        if (!this.state.email) {
            errors.email_error_message = searchLocale.EMAIL_ADDRESS_INPUT.ERROR_REQUIRED;
        } else if (!this.emailValid(this.state.email)) {
            errors.email_error_message = searchLocale.EMAIL_ADDRESS_INPUT.ERROR_INVALID;
        }

        if (Object.keys(errors).length > 0) {
            this.setState(errors);
            return;
        }

        this.props.search(this.state.order_no, this.state.email);
    };

    render() {
        const { locale } = this.getResolvedContext();

        return (
            <section className="flex layout horizontal center-center">
                {this.props.language_list_loading || this.props.store_list_loading || this.props.country_list_loading ? (
                    <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                ) : (
                    <div className="flex layout vertical search-main-frame search">
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <h1 className="layout vertical frame-heading center-center">{locale.SEARCH_PAGE.HEADING}</h1>
                                </div>
                            </div>
                        </div>
                        {this.props.search_message && (
                            <div className="box">
                                <div className="row">
                                    <div className="column">
                                        <div className="message-box">{this.props.search_message}</div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <div className="input-box">
                                        <div className="flex layout justified horizontal">
                                            <div className="input-heading">*{locale.SEARCH_PAGE.ORDER_NUMBER_INPUT.HEADER}</div>
                                        </div>
                                        <div className="flex layout horizontal">
                                            <input
                                                onChange={e => this.handleInputChange("order_no", e)}
                                                className="custom-input"
                                                placeholder={this.getOrderNumberPlaceholder()}
                                            />
                                        </div>
                                        <div className="flex input-error-box">
                                            <div className="input-helper-text">{this.state.order_no_error_message}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="column">
                                    <div className="input-box">
                                        <div className="flex">
                                            <div className="input-heading">*{locale.SEARCH_PAGE.EMAIL_ADDRESS_INPUT.HEADER}</div>
                                        </div>
                                        <div className="flex layout horizontal">
                                            <input onChange={e => this.handleInputChange("email", e)} className="custom-input" placeholder="name@domain.com" />
                                        </div>
                                        <div className="flex input-error-box">
                                            <div className="input-helper-text">{this.state.email_error_message}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <div className="layout horizontal justified center-center">
                                        <button
                                            className={`flex custom-button view-order layout horizontal center-center ${this.props.loading ? "loading" : ""}`}
                                            onClick={this.props.loading ? null : this.handleSearch}
                                        >
                                            <div className="layout vertical center-center inbutton-text">
                                                {this.props.loading || this.props.language_list_loading || this.props.store_list_loading ? (
                                                    <CircularProgress size={24} className="circular-loading" thickness={6} />
                                                ) : (
                                                    locale.SEARCH_PAGE.SEARCH_BUTTON_TEXT
                                                )}
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <div className="forgot-order-no-input-box">
                                        <Link className="input-heading linked-text" to={this.getForgotOrderNoPath()} onClick={this.handleForgotOrderNoClick}>
                                            {locale.SEARCH_PAGE.FORGOT_YOUR_ORDER_NUMBER}?
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        );
    }
}

export default withRouter(Search);
